import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div>
        {eyebrow && (
          <span className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-600 uppercase">
            <span className="h-3 w-1 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">{description}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-500 cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}